import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../Reception/Style.css';
import {Col, Row} from "reactstrap";
import image from "../../assets/img/logos/event_logo_without_shadow.png";
import {connect} from "react-redux";

const propTypes = {
  children: PropTypes.node,
};
const defaultProps = {};

class DefaultFooter extends Component {
  state = {
    isOffline: false,
    isInquiries: false,
  };

  render() {
    let {results} = this.props;

    return (
      <React.Fragment>
        {results && <Row>
          <Col md={3} className={"justify-center"}>
            {/*{results.image ? <img className={"event-main-logo"} src={results.image} alt={"event-logo"}/> : null}*/}
          </Col>
          <Col md={7} />
          <Col md={2} className={"justify-center"}>
            <div className={"align-right"}>
              <img className={"event-logo"} src={image} alt={"event-logo"}/>
            </div>
          </Col>
        </Row>}
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  results: state.socketReducer.result
});

export default connect(mapStateToProps)(DefaultFooter);
